(() => {
  const handleTabToggle = () => {
    const tabContent = document.querySelector('.offer-container');
    const arrow = document.querySelector('.offer-container .offer-header .button-arrow');      
    const overlay = document.querySelector('.offer-tabs-overlay');

    tabContent.classList.toggle('show'); 
    overlay.classList.toggle('show'); 
    arrow.classList.toggle('up');
  };  

  // Event listeners
  document.querySelector('.offer-container .offer-header .button-container')
    .addEventListener('click', handleTabToggle);

    
  const discountCode = document.querySelectorAll('.offer-discount-code');

  Array.prototype.forEach.call(discountCode, function(element) {
    element.addEventListener('click', function () {
      navigator.clipboard.writeText(element.dataset.offercode);
      element.classList.add("show-tooltip");
      setTimeout(function(){
        element.classList.remove("show-tooltip");
      }, 1000);
    });
  });

  document.addEventListener('click', function(event) {
    const container = document.querySelector('.offer-container');
    if (container && !container.contains(event.target)) {
      container.classList.remove('show'); 
      document.querySelector('.offer-tabs-overlay').classList.remove('show');
    }
  });
})();